/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { GET_LISTDATA } from "../../actions";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { apiUrl, adminlimit, headerconfig } from "../Settings/Config";
import { format } from "date-fns";
import {
  showContaimerLoader,
  userID,
  showPriceValue,
  encodeValue,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "reports/";
var moduleName = "Sales Statistics Report";

class List extends Component {
  constructor(props) {
    super(props);
    console.log(this.props, "this.props");
    let filterMonth = this.props.match.params?.monthYear || "";
    let customerID = this.props.match.params?.customerID || "";
    this.state = {
      userID: userID(),
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      filterMonth: filterMonth,
      customerID: customerID,
      start_date: "",
      end_date: "",
      customer: "",
      customerList: [],
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadCustomer();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        start_date: "",
        end_date: "",
        customer: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.customer?.value) {
      addParams += "&customer=" + this.state.customer.value;
    }

    if (this.state.start_date) {
      addParams +=
        "&start_date=" + format(new Date(this.state.start_date), "yyyy-MM-dd");
    }
    if (this.state.end_date) {
      addParams +=
        "&end_date=" + format(new Date(this.state.end_date), "yyyy-MM-dd");
    }
    addParams += "&filterMonth=" + this.state.filterMonth;

    var params = {
      params:
        "limit=" +
        adminlimit +
        "&offset=" +
        offset +
        "&userID=" +
        this.state.userID +
        addParams,
      url: apiUrl + "reports/getOverallStatistics",
    };
    this.props.getListData(params);
  }
  loadCustomer() {
    var urlShringTxt =
      apiUrl + "customer/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        var result = res.data.result;
        var customer = "";
        if (result.length > 0) {
          result.map((item) => {
            if (item.value === this.state.customerID) {
              customer = item;
            }
          });
        }
        this.setState(
          { customerList: res.data.result, customer: customer },
          () => {
            this.loadList(1);
          }
        );
      } else {
        this.loadList(1);
      }
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  handleChangeDate(name, value) {
    this.setState({ [name]: value });
  }

  gotoDetails(type, filterType) {
    this.props.history.push(`/report/statistics/${type}/${filterType}`);
  }

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="statistics-report" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                  </div>

                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            {/* <div className="col-md-3">
                              <Select
                                value={this.state.customer}
                                onChange={this.handleSelectChange.bind(
                                  this,
                                  "customer"
                                )}
                                placeholder="Select Customer"
                                isClearable={true}
                                options={this.state.customerList}
                              />
                            </div> */}
                            <div className="col-md-2">
                              <div className="form-floating form-floating-outline">
                                <DatePicker
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control"
                                  selected={this.state.start_date}
                                  dateFormat="dd-MM-yyyy"
                                  placeholderText="Start Date"
                                  onChange={this.handleChangeDate.bind(
                                    this,
                                    "start_date"
                                  )}
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-floating form-floating-outline">
                                <DatePicker
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control"
                                  selected={this.state.end_date}
                                  minDate={
                                    this.state.start_date !== ""
                                      ? this.state.start_date
                                      : ""
                                  }
                                  dateFormat="dd-MM-yyyy"
                                  placeholderText="Start Date"
                                  onChange={this.handleChangeDate.bind(
                                    this,
                                    "end_date"
                                  )}
                                />
                              </div>
                            </div>

                            <div className="col-md-3">
                              <a
                                href={void 0}
                                className="btn btn-primary"
                                onClick={this.searchList.bind(this)}
                              >
                                Search
                              </a>
                              <a
                                href={void 0}
                                className="btn btn-secondary offset-1"
                                onClick={this.resetSearch.bind(this)}
                              >
                                Reload
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    {this.state.loading ? (
                      showContaimerLoader()
                    ) : (
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-12 col-xl-3 curs" onClick={this.gotoDetails.bind(this, 'sale', 'totalsale')}>
                            <div className="card overflow-hidden">
                              <div className="card-body">
                                <div className="d-flex">
                                  <div className="mt-2">
                                    <h6 className="">Total Salse</h6>
                                    <h2 className="mb-0 number-font">
                                      {showPriceValue(this.state.listdata.totalSale)}
                                    </h2>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-12 col-xl-3 curs" onClick={this.gotoDetails.bind(this, 'sale', 'recived')}>
                            <div className="card overflow-hidden">
                              <div className="card-body">
                                <div className="d-flex">
                                  <div className="mt-2">
                                    <h6 className="">Recived Bill</h6>
                                    <h2 className="mb-0 number-font" >
                                      {showPriceValue(this.state.listdata.totalrecived)}
                                    </h2>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-12 col-xl-3 curs" onClick={this.gotoDetails.bind(this, 'sale', 'pending')}>
                            <div className="card overflow-hidden">
                              <div className="card-body">
                                <div className="d-flex">
                                  <div className="mt-2">
                                    <h6 className="">Receivable Bill</h6>
                                    <h2 className="mb-0 number-font">
                                      {showPriceValue(this.state.listdata.balanceBillAmount)}
                                    </h2>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-12 col-xl-3 curs" onClick={this.gotoDetails.bind(this, 'purchase', 'total')}>
                            <div className="card overflow-hidden">
                              <div className="card-body">
                                <div className="d-flex">
                                  <div className="mt-2">
                                    <h6 className="">Total Purchase</h6>
                                    <h2 className="mb-0 number-font">
                                      {showPriceValue(this.state.listdata.totalpurchase)}
                                    </h2>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-12 col-xl-3 curs" onClick={this.gotoDetails.bind(this, 'purchase', 'paid')}>
                            <div className="card overflow-hidden">
                              <div className="card-body">
                                <div className="d-flex">
                                  <div className="mt-2">
                                    <h6 className="">Paid Purchase Bill</h6>
                                    <h2 className="mb-0 number-font">
                                      {showPriceValue(this.state.listdata.purchasetotalrecived)}
                                    </h2>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-12 col-xl-3 curs" onClick={this.gotoDetails.bind(this, 'purchase', 'pending')}>
                            <div className="card overflow-hidden">
                              <div className="card-body">
                                <div className="d-flex">
                                  <div className="mt-2">
                                    <h6 className="">Payable Purchase Bill</h6>
                                    <h2 className="mb-0 number-font">
                                      {showPriceValue(this.state.listdata.balancepurchaseBillAmount)}
                                    </h2>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>                          
                          
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = Array();
  var listdataStatus = "";
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    listdataStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
